import type { OutboundMediaTipo } from '@/shared/types/midiaDeSaida';

/**
 * Nome em português de cada tipo de mídia da conversa. Fonte única para o chat e os documentos da
 * negociação e para a conversa e a exportação da simulação: os quatro mostram o mesmo arquivo.
 */
export const ROTULO_DO_TIPO_DE_MIDIA: Record<OutboundMediaTipo, string> = {
  DOCUMENT: 'Documento',
  IMAGE: 'Imagem',
  AUDIO: 'Áudio',
  VIDEO: 'Vídeo',
};
